import { useState } from 'react'
import { t } from 'i18next'
import { IFormModel } from 'types'

/**
 * Form constants
 */
const SEARCH = 'search'
const SUBJECT = 'subject'
const DOMAIN = 'domain'
const CLUSTER = 'cluster'
const GRADE_LEVEL = 'grade_level'
const GROUP = 'group'
const STUDENT = 'student'
const CREATED_AFTER = 'created_at_after'
const CREATED_BEFORE = 'created_at_before'

/**
 * Form model
 */
const formModel = (): IFormModel  => {
  return {
    [SEARCH]: {
      label: `${t('common.search-table')}`,
      name: SEARCH,
    },
    [SUBJECT]: {
      label: `${t('common.subject')}`,
      name: SUBJECT,
    },
    [DOMAIN]: {
      label: `${t('common.domain')}`,
      name: DOMAIN,
    },
    [CLUSTER]: {
      label: `${t('common.cluster')}`,
      name: CLUSTER,
    },
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
    },
    [GROUP]: {
      label: `${t('common.group')}`,
      name: GROUP,
    },
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
    },
    [CREATED_AFTER]: {
      label: `${t('common.from')}`,
      name: CREATED_AFTER,
    },
    [CREATED_BEFORE]: {
      label: `${t('common.to')}`,
      name: CREATED_BEFORE,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SEARCH]: '',
  [SUBJECT]: null,
  [DOMAIN]: null,
  [CLUSTER]: null,
  [GRADE_LEVEL]: null,
  [GROUP]: null,
  [STUDENT]: null,
  [CREATED_AFTER]: null,
  [CREATED_BEFORE]: null,
}

/**
 * Form state
 */
export const useParams = () => {
  const [params, setParams] = useState(initialValues)

  return { params, setParams }
}

export default formModel
